import moment from 'moment';

export default {
    data() {
        return {

        };
    },

    methods: {
        isValidDateTimeString(dateTimeString) {
            return moment(dateTimeString, this.newDateTimeFormat, true).isValid();
        },

        getUserTimestamp() {
            return this.getToday(this.i18nDateFormat) + " " + this.getNowTime(this.i18nTimeFormat) + ", " + this.$store.getters["userInfo"].Name + ":\n";
        },

        getToday(format, addedDays, addedMonths, addedYears) {
            var today = this.oldFormatDate(moment());
            var date = this.addDates(null, today, addedDays, addedMonths, addedYears)
            return date.format(format);
        },

        addDates(outputformat, indate, days, months, years) {
            var date = moment(indate, this.acceptedDateFormats);
            if (years) {
                date.add(years, 'years')
            }
            if (months) {
                date.add(months, 'months')
            }
            if (days) {
                date.add(days, 'days')
            }
            return outputformat ? date.format(outputformat) : date;
        },

        getNowTime(format, addedHours, addedMinutes) {
            var now = this.oldFormatTime(moment());
            var time = this.addTime(null, now, addedHours, addedMinutes)
            return time.format(format);
        },

        addTime(outputformat, intime, addedHours, addedMinutes, addedSeconds) {
            var time = moment(intime, this.acceptedTimeFormats);
            if (addedHours) {
                time.add(addedHours, 'hours')
            }
            if (addedMinutes) {
                time.add(addedMinutes, 'minutes')
            }
            if (addedSeconds) {
                time.add(addedSeconds, 'seconds')
            }
            return outputformat ? time.format(outputformat) : time;
        },

        comparedatetime(datetime1, datetime2) {
            var moment1 = moment(datetime1, this.acceptedDateTimeFormats);
            var moment2 = moment(datetime2, this.acceptedDateTimeFormats);
            var math = moment1 > moment2;
            return math;
        },

        //used to compare two time stamps, it returns a boolean based on weather the first one was the largest
        comparetime(time1, time2) {
            var momenttime1 = moment(time1, this.acceptedTimeFormats);
            var momenttime2 = moment(time2, this.acceptedTimeFormats);
            var time1minutes = momenttime1.hours() * 60 + momenttime1.minutes();
            var time2minutes = momenttime2.hours() * 60 + momenttime2.minutes();
            var math = time1minutes > time2minutes;

            return math;
        },

        getMontYear(indate) {
            var dateparsed = moment(indate, this.acceptedDateFormats);
            return dateparsed.format('MMMM yyyy');
        },

        //I18N format methods
        i18nFormatDateTime(datetimestring) {
            return this.formatDateTimeAdvanced(datetimestring, this.i18nDateTimeFormat);
        },
        i18nFormatDate(datestring) {
            return this.formatDateAdvanced(datestring, this.i18nDateFormat);
        },
        i18nFormatTime(timestring) {
            return this.formatTimeAdvanced(timestring, this.i18nTimeFormat);
        },

        //Vuetify format methods
        VuetifyFormatDateTime(datetimestring) {
            return this.formatDateAdvanced(datetimestring, this.VuetifyDateTimeFormat);
        },
        VuetifyFormatDate(datestring) {
            return this.formatDateAdvanced(datestring, this.VuetifyDateFormat);
        },
        VuetifyFormatTime(timestring) {
            return this.formatTimeAdvanced(timestring, this.VuetifyTimeFormat);
        },

        //Old format methods
        oldFormatDateTime(datestring) {
            return this.formatDateAdvanced(datestring, this.oldDateTimeFormat);
        },
        oldFormatDate(datestring) {
            return this.formatDateAdvanced(datestring, this.oldDateFormat);
        },
        oldFormatTime(timestring) {
            return this.formatTimeAdvanced(timestring, this.oldTimeFormat);
        },

        formatDateTimeAdvanced(string, outputformat) {
            var retval = null;
            var momentval = moment.utc(string, this.acceptedDateTimeFormats);
            if (momentval._isValid) {
                retval = momentval.local().format(outputformat);
            }
            return retval;
        },
        formatDateAdvanced(string, outputformat) {
            var retval = null;
            if (string == null || string === '') {
                return retval;
            }
            // Try accepted formats first (incl. locale DD.MM-YYYY) to avoid passing non-ISO
            // strings to moment.utc(string), which triggers a deprecation warning.
            var momentval = moment.utc(string, this.acceptedDateFormats);
            if (!momentval.isValid()) {
                momentval = moment.utc(string);
            }
            if (momentval.isValid()) {
                retval = momentval.local().format(outputformat);
            }
            return retval;
        },
        formatTimeAdvanced(mystring, outputformat) {
            var retval = null;
            var momentval = moment.utc(mystring, this.acceptedTimeFormats);
            if (momentval._isValid) {
                retval = momentval.local().format(outputformat);
            }
            return retval;
        },

        getDateFromString(string) {
            return moment(string, this.acceptedDateFormats).toDate();
        },

        isToday(inDate) {
            var today = new Date();
            return inDate.getDate() === today.getDate() && inDate.getMonth() === today.getMonth() && inDate.getFullYear() === today.getFullYear();
        },

        isYesterday(inDate) {
            var today = new Date();
            return inDate.getDate() === (today.getDate() - 1) && inDate.getMonth() === today.getMonth() && inDate.getFullYear() === today.getFullYear();
        },

        //Erik's format methods
        formatDate(dateTime) {
            var f = new Date(dateTime);
            return f.toLocaleDateString();
        },
        formatDateTime(dateTime) {
            var f = new Date(dateTime);
            return f.toLocaleString();
        },
    },

    computed: {
        //I18N
        i18nDateTimeFormat() {
            return this.$t("servicesystem.formatting.datetimeformat")
        },
        i18nDateFormat() {
            return this.$t("servicesystem.formatting.dateformat")
        },
        i18nTimeFormat() {
            return this.$t("servicesystem.formatting.timeformat")
        },

        //OLD
        oldDateTimeFormat() {
            return "YYYY-MM-DDTHH:mm:ss"
        },
        oldDateFormat() {
            return "YYYY-MM-DD"
        },
        oldTimeFormat() {
            return "HH:mm:ss"
        },

        newTimeFormat() {
            return "HH:mm:ssZ"
        },
        newDateTimeFormat() {
            return "YYYY-MM-DDTHH:mm:ssZ"
        },
        //VUETIFY
        VuetifyDateFormat() {
            return "YYYY-MM-DD";
        },
        VuetifyTimeFormat() {
            return "HH:mm";
        },

        //All in array
        acceptedDateTimeFormats() {
            return [this.i18nDateTimeFormat, this.oldDateTimeFormat, this.newDateTimeFormat];
        },
        acceptedDateFormats() {
            return [this.i18nDateFormat, this.oldDateTimeFormat, this.oldDateFormat, this.VuetifyDateFormat];
        },
        acceptedTimeFormats() {
            return [this.newTimeFormat, this.i18nTimeFormat, this.oldDateTimeFormat, this.oldTimeFormat, this.VuetifyTimeFormat];
        },
    },
}